(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("9e4lR", function(module, exports) {
    $parcel$export(module.exports, "MODAL_OPEN_REQUEST_EVENT", function() {
      return $6b78cbfbaadac19a$export$3a3ec5884c2bdab0;
    });
    $parcel$export(module.exports, "MODAL_OPENED_EVENT", function() {
      return $6b78cbfbaadac19a$export$16a5d99daeabc70f;
    });
    $parcel$export(module.exports, "MODAL_OPEN_FAILED_EVENT", function() {
      return $6b78cbfbaadac19a$export$3e10ac5c14d1b477;
    });
    $parcel$export(module.exports, "createModalRequestId", function() {
      return $6b78cbfbaadac19a$export$6966a06f04e186a1;
    });
    const $6b78cbfbaadac19a$export$3a3ec5884c2bdab0 = "mbf:modal-open-request";
    const $6b78cbfbaadac19a$export$16a5d99daeabc70f = "mbf:modal-opened";
    const $6b78cbfbaadac19a$export$3e10ac5c14d1b477 = "mbf:modal-open-failed";
    function $6b78cbfbaadac19a$export$6966a06f04e186a1() {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    function $6b78cbfbaadac19a$export$dee6409cd6d872a1(detail = {}) {
      const {requestId: requestId = null, baseUrl: baseUrl = null, url: url = null, view: view = null, strategy: strategy = null, context: context = null, modalId: modalId = null, source: source = null} = detail;
      return {
        requestId: requestId,
        baseUrl: baseUrl,
        url: url,
        view: view,
        strategy: strategy,
        context: context,
        modalId: modalId,
        sourceType: source?.type || null,
        sourceId: source?.id || null
      };
    }
  });
  parcelRegister("7bS3h", function(module, exports) {
    $parcel$export(module.exports, "default", function() {
      return $53c37d114b9030f9$export$2e2bcd8739ae039;
    });
    function $53c37d114b9030f9$export$2e2bcd8739ae039(cents, format) {
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.Shopify?.money_format || "${{amount}}";
      const defaultOption = (opt, def) => typeof opt === "undefined" ? def : opt;
      const formatWithDelimiters = (number, precision, thousands, decimal) => {
        const resolvedPrecision = defaultOption(precision, 2);
        const resolvedThousands = defaultOption(thousands, ",");
        const resolvedDecimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) return 0;
        const fixed = (number / 100).toFixed(resolvedPrecision);
        const parts = fixed.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + resolvedThousands);
        const centsPart = parts[1] ? resolvedDecimal + parts[1] : "";
        return dollars + centsPart;
      };
      let normalized = cents;
      if (typeof normalized === "string") normalized = normalized.replace(".", "");
      const match = formatString.match(placeholderRegex);
      const token = match ? match[1] : "amount";
      switch (token) {
       case "amount":
        value = formatWithDelimiters(normalized, 2);
        break;

       case "amount_no_decimals":
        value = formatWithDelimiters(normalized, 0);
        break;

       case "amount_with_comma_separator":
        value = formatWithDelimiters(normalized, 2, ".", ",");
        break;

       case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(normalized, 0, ".", ",");
        break;

       default:
        value = formatWithDelimiters(normalized, 2);
        break;
      }
      return formatString.replace(placeholderRegex, value).replace(/(\.|,)00$/g, "");
    }
  });
  parcelRegister("gjV2B", function(module, exports) {
    $parcel$export(module.exports, "debounce", function() {
      return $be1aaad8d43db719$export$61fc7d43ac8f84b0;
    });
    const $be1aaad8d43db719$export$61fc7d43ac8f84b0 = (func, wait) => {
      let timeout;
      const debounced = (...args) => {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
      debounced.cancel = () => {
        clearTimeout(timeout);
        timeout = null;
      };
      return debounced;
    };
  });
  parcelRegister("YjNU1", function(module, exports) {
    $parcel$export(module.exports, "initSwymBis", function() {
      return $0b54f75990233cb1$export$23cdde14ed5ac142;
    });
    const $0b54f75990233cb1$var$ALLOWED_MEDIA = new Set([ "email", "sms" ]);
    const $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS = [ "epi", "empi", "du", "pr", "iu" ];
    const $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC = "backinstock";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE = "Swym mailing list opt-in is not enabled. Enable the mailing list feature in the Swym dashboard and the theme setting before sending addToMailingList: 1.";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE = "Newsletter opt-in is not available right now. Untick the newsletter box and try again.";
    function $0b54f75990233cb1$var$deferCallback(callback) {
      if (typeof queueMicrotask === "function") {
        queueMicrotask(callback);
        return;
      }
      Promise.resolve().then(callback);
    }
    function $0b54f75990233cb1$var$normalizeSwymSuccessArgs(args) {
      if (!Array.isArray(args) || args.length === 0) return null;
      if (args.length === 1) return args[0];
      return args;
    }
    function $0b54f75990233cb1$var$stringifySwymCallbackValue(value) {
      if (value instanceof Error) return value.message || value.name || "Error";
      if (typeof value === "string") return value.trim() || "empty string";
      if (value === undefined) return "undefined";
      if (value === null) return "null";
      try {
        return JSON.stringify(value);
      } catch (_error) {
        return Object.prototype.toString.call(value);
      }
    }
    function $0b54f75990233cb1$var$getSwymObjectMessage(value) {
      const message = value.message || value.error || value.msg || value.description;
      if (typeof message === "string" && message.trim()) return message.trim();
      if (message && typeof message === "object") return $0b54f75990233cb1$var$stringifySwymCallbackValue(message);
      const responseText = value.responseText || value.response?.text;
      if (typeof responseText === "string" && responseText.trim()) try {
        const parsed = JSON.parse(responseText);
        return $0b54f75990233cb1$var$getSwymObjectMessage(parsed) || $0b54f75990233cb1$var$stringifySwymCallbackValue(parsed);
      } catch (_error) {
        return responseText.trim();
      }
      return "";
    }
    function $0b54f75990233cb1$var$normalizeSwymErrorArgs(args, context = {}) {
      const values = Array.isArray(args) ? args : [ args ];
      const firstDefined = values.find(value => value !== undefined && value !== null);
      const callbackArgs = values.map($0b54f75990233cb1$var$stringifySwymCallbackValue).join(", ");
      const contextDetails = Object.entries(context).filter(([, value]) => value !== undefined && value !== null && value !== "").map(([key, value]) => `${key}: ${$0b54f75990233cb1$var$stringifySwymCallbackValue(value)}`).join(", ");
      const suffixParts = [];
      if (callbackArgs) suffixParts.push(`callback args: ${callbackArgs}`);
      if (contextDetails) suffixParts.push(`request: ${contextDetails}`);
      const withDetails = message => {
        const normalizedMessage = typeof message === "string" && message.trim() ? message.trim() : "subscribeForProductAlert failed";
        const details = suffixParts.length ? ` (${suffixParts.join("; ")})` : "";
        const error = new Error(`[swym-bis] ${normalizedMessage}${details}`);
        error.swymCallbackArgs = values;
        error.swymRequestContext = context;
        return error;
      };
      if (firstDefined instanceof Error) {
        const error = withDetails(firstDefined.message || firstDefined.name);
        error.cause = firstDefined;
        return error;
      }
      if (typeof firstDefined === "string" && firstDefined.trim()) return withDetails(firstDefined);
      if (firstDefined && typeof firstDefined === "object") return withDetails($0b54f75990233cb1$var$getSwymObjectMessage(firstDefined));
      return withDetails();
    }
    function $0b54f75990233cb1$var$assertRuntime() {
      if (typeof window === "undefined") throw new Error("[swym-bis] window is unavailable");
    }
    function $0b54f75990233cb1$var$normalizeAndValidateProduct(product) {
      if (!product || typeof product !== "object") throw new Error("[swym-bis] product must be an object");
      for (const field of $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS) {
        if (!(field in product) || product[field] === null || product[field] === "") throw new Error(`[swym-bis] missing required product field "${field}"`);
      }
      const du = String(product.du).trim().split("#")[0].split("?")[0];
      if (!du) throw new Error("[swym-bis] product.du must be a valid canonical URL");
      return {
        epi: product.epi,
        empi: product.empi,
        du: du,
        pr: product.pr,
        iu: String(product.iu).trim()
      };
    }
    function $0b54f75990233cb1$var$validateMedium(mediumValue, medium) {
      if (!mediumValue || typeof mediumValue !== "string" || mediumValue.trim().length === 0) throw new Error("[swym-bis] mediumValue is required");
      if (!$0b54f75990233cb1$var$ALLOWED_MEDIA.has(medium)) throw new Error('[swym-bis] medium must be either "email" or "sms"');
    }
    function $0b54f75990233cb1$var$isMailingListOptInEnabled() {
      return window.MBF?.settings?.enableBackInStockMailingList === true;
    }
    function $0b54f75990233cb1$var$createSwymBisRuntime() {
      let swatRef = null;
      const availableCallbacks = new Set;
      let readyResolve;
      const readyPromise = new Promise(resolve => {
        readyResolve = resolve;
      });
      const hasBisSubscribeCapability = () => Boolean(swatRef && typeof swatRef.subscribeForProductAlert === "function");
      const setReady = swat => {
        if (!swat || swatRef) return;
        swatRef = swat;
        readyResolve();
        if (!hasBisSubscribeCapability()) return;
        availableCallbacks.forEach(callback => callback());
        availableCallbacks.clear();
      };
      if (window._swat) setReady(window._swat);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(setReady);
      return {
        ready() {
          return readyPromise;
        },
        isAvailable() {
          return hasBisSubscribeCapability();
        },
        onAvailable(callback) {
          if (typeof callback !== "function") return () => {};
          if (hasBisSubscribeCapability()) {
            callback();
            return () => {};
          }
          availableCallbacks.add(callback);
          return () => availableCallbacks.delete(callback);
        },
        async subscribeForBackInStock({mediumValue: mediumValue, medium: medium = "email", product: product, addToMailingList: addToMailingList = 0} = {}) {
          $0b54f75990233cb1$var$validateMedium(mediumValue, medium);
          const normalizedProduct = $0b54f75990233cb1$var$normalizeAndValidateProduct(product);
          const normalizedAddToMailingList = Number(addToMailingList) === 1 ? 1 : 0;
          if (normalizedAddToMailingList === 1 && !$0b54f75990233cb1$var$isMailingListOptInEnabled()) {
            const error = new Error(`[swym-bis] ${$0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE}`);
            error.userMessage = $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE;
            error.swymRequestContext = {
              medium: medium,
              product: normalizedProduct,
              addToMailingList: normalizedAddToMailingList,
              topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
            };
            throw error;
          }
          await readyPromise;
          return new Promise((resolve, reject) => {
            let settled = false;
            const resolveOnce = value => {
              if (settled) return;
              settled = true;
              resolve(value);
            };
            const rejectOnceDeferred = (...errorArgs) => {
              const normalizedError = $0b54f75990233cb1$var$normalizeSwymErrorArgs(errorArgs, {
                medium: medium,
                product: normalizedProduct,
                addToMailingList: normalizedAddToMailingList,
                topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
              });
              $0b54f75990233cb1$var$deferCallback(() => {
                if (settled) return;
                settled = true;
                reject(normalizedError);
              });
            };
            swatRef.subscribeForProductAlert(mediumValue.trim(), medium, normalizedProduct, (...successArgs) => resolveOnce($0b54f75990233cb1$var$normalizeSwymSuccessArgs(successArgs)), (...errorArgs) => rejectOnceDeferred(...errorArgs), normalizedAddToMailingList, $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC);
          });
        }
      };
    }
    function $0b54f75990233cb1$export$23cdde14ed5ac142() {
      $0b54f75990233cb1$var$assertRuntime();
      window.MBF = window.MBF || {};
      if (window.MBF.swymBis) return window.MBF.swymBis;
      const runtime = $0b54f75990233cb1$var$createSwymBisRuntime();
      window.MBF.swymBis = runtime;
      return runtime;
    }
  });
  parcelRegister("cJzMp", function(module, exports) {
    $parcel$export(module.exports, "createLogger", function() {
      return $94557121a748c06f$export$fe2e61603b61130d;
    });
    $parcel$export(module.exports, "serializeError", function() {
      return $94557121a748c06f$export$46ff38bc6bdea8fb;
    });
    $parcel$export(module.exports, "withDebugReason", function() {
      return $94557121a748c06f$export$4ecc6b6d3cd743de;
    });
    const $94557121a748c06f$var$LS_KEY = "mbf_debug";
    const $94557121a748c06f$var$CATEGORIES = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    const $94557121a748c06f$var$CATEGORY_STYLES = {
      lifecycle: "color:#6366f1;font-weight:bold",
      events: "color:#10b981;font-weight:bold",
      network: "color:#3b82f6;font-weight:bold",
      ui: "color:#f59e0b;font-weight:bold",
      animation: "color:#ec4899;font-weight:bold",
      errors: "color:#ef4444;font-weight:bold"
    };
    const $94557121a748c06f$var$FILE_STYLE = "color:#94a3b8;font-style:italic";
    const $94557121a748c06f$var$LABEL_STYLE = "color:#475569";
    const $94557121a748c06f$var$BATCH_WINDOW_MS = 120;
    const $94557121a748c06f$var$GROUPED_LOG_RULES = [ {
      file: "tagalys-helpers",
      category: "ui"
    } ];
    const $94557121a748c06f$var$groupedLogBuffers = new Map;
    const $94557121a748c06f$var$groupedLogTimers = new Map;
    function $94557121a748c06f$var$defaultConfig() {
      const categories = {};
      $94557121a748c06f$var$CATEGORIES.forEach(c => categories[c] = true);
      return {
        enabled: false,
        categories: categories,
        files: {}
      };
    }
    function $94557121a748c06f$var$load() {
      try {
        const raw = localStorage.getItem($94557121a748c06f$var$LS_KEY);
        if (!raw) return $94557121a748c06f$var$defaultConfig();
        const parsed = JSON.parse(raw);
        const cfg = $94557121a748c06f$var$defaultConfig();
        cfg.enabled = !!parsed.enabled;
        if (parsed.categories && typeof parsed.categories === "object") Object.keys(cfg.categories).forEach(k => {
          if (k in parsed.categories) cfg.categories[k] = !!parsed.categories[k];
        });
        if (parsed.files && typeof parsed.files === "object") cfg.files = parsed.files;
        return cfg;
      } catch {
        return $94557121a748c06f$var$defaultConfig();
      }
    }
    function $94557121a748c06f$var$save(cfg) {
      try {
        localStorage.setItem($94557121a748c06f$var$LS_KEY, JSON.stringify(cfg));
      } catch {}
    }
    let $94557121a748c06f$var$_config = typeof window !== "undefined" ? $94557121a748c06f$var$load() : {
      enabled: false
    };
    function $94557121a748c06f$var$_emit(filename, category, args) {
      if (!$94557121a748c06f$var$_config.enabled) return;
      if (!$94557121a748c06f$var$_config.categories[category]) return;
      if ($94557121a748c06f$var$_config.files[filename] === false) return;
      if ($94557121a748c06f$var$shouldGroupLog(filename, category)) {
        $94557121a748c06f$var$queueGroupedLog(filename, category, args);
        return;
      }
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const prefix = `%c[DEBUG] %c[${category}] %c[${filename}]`;
      if (category === "errors") console.error(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args); else console.log(prefix, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, ...args);
    }
    function $94557121a748c06f$var$shouldGroupLog(filename, category) {
      return $94557121a748c06f$var$GROUPED_LOG_RULES.some(rule => rule.file === filename && rule.category === category);
    }
    function $94557121a748c06f$var$groupedKey(filename, category) {
      return `${filename}::${category}`;
    }
    function $94557121a748c06f$var$queueGroupedLog(filename, category, args) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key) || [];
      buffer.push(args);
      $94557121a748c06f$var$groupedLogBuffers.set(key, buffer);
      if ($94557121a748c06f$var$groupedLogTimers.has(key)) return;
      const timer = setTimeout(() => {
        $94557121a748c06f$var$groupedLogTimers.delete(key);
        $94557121a748c06f$var$flushGroupedLogs(filename, category);
      }, $94557121a748c06f$var$BATCH_WINDOW_MS);
      $94557121a748c06f$var$groupedLogTimers.set(key, timer);
    }
    function $94557121a748c06f$var$flushGroupedLogs(filename, category) {
      const key = $94557121a748c06f$var$groupedKey(filename, category);
      const buffer = $94557121a748c06f$var$groupedLogBuffers.get(key);
      if (!buffer || buffer.length === 0) return;
      $94557121a748c06f$var$groupedLogBuffers.delete(key);
      const catStyle = $94557121a748c06f$var$CATEGORY_STYLES[category] ?? "color:#64748b;font-weight:bold";
      const header = `%c[DEBUG] %c[${category}] %c[${filename}] %c(${buffer.length} logs batched)`;
      console.groupCollapsed(header, $94557121a748c06f$var$LABEL_STYLE, catStyle, $94557121a748c06f$var$FILE_STYLE, "color:#64748b");
      buffer.forEach(entryArgs => {
        console.log(...entryArgs);
      });
      console.groupEnd();
    }
    function $94557121a748c06f$var$createRealLogger(filename) {
      return function log(category, ...args) {
        $94557121a748c06f$var$_emit(filename, category, args);
      };
    }
    const $94557121a748c06f$export$fe2e61603b61130d = () => () => {};
    function $94557121a748c06f$export$46ff38bc6bdea8fb(error) {
      if (error instanceof Error) return {
        name: error.name,
        message: error.message,
        stack: error.stack
      };
      return {
        value: error
      };
    }
    function $94557121a748c06f$export$4ecc6b6d3cd743de(reason, details = {}) {
      return {
        reason: reason,
        ...details
      };
    }
    const $94557121a748c06f$export$282d649a8a633ddc = {
      start() {
        $94557121a748c06f$var$_config.enabled = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging enabled. Reload the page for full coverage.", "color:#10b981;font-weight:bold");
        this.status();
      },
      stop() {
        $94557121a748c06f$var$_config.enabled = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log("%c[DEBUG] Logging disabled.", "color:#ef4444;font-weight:bold");
      },
      enable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = true;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" enabled.`, "color:#10b981");
      },
      disable(category) {
        if (!$94557121a748c06f$var$CATEGORIES.includes(category)) {
          console.warn(`[DEBUG] Unknown category "${category}". Available: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`);
          return;
        }
        $94557121a748c06f$var$_config.categories[category] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] Category "${category}" disabled.`, "color:#f59e0b");
      },
      enableFile(file) {
        delete $94557121a748c06f$var$_config.files[file];
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" re-enabled.`, "color:#10b981");
      },
      disableFile(file) {
        $94557121a748c06f$var$_config.files[file] = false;
        $94557121a748c06f$var$save($94557121a748c06f$var$_config);
        console.log(`%c[DEBUG] File "${file}" disabled.`, "color:#f59e0b");
      },
      status() {
        const categoryRows = $94557121a748c06f$var$CATEGORIES.map(c => ({
          category: c,
          enabled: $94557121a748c06f$var$_config.categories[c] ? "✅" : "❌"
        }));
        const fileRows = Object.entries($94557121a748c06f$var$_config.files).map(([f, v]) => ({
          file: f,
          enabled: v ? "✅" : "❌"
        }));
        console.group("%c[DEBUG] Status", "color:#6366f1;font-weight:bold");
        console.log("Logging:", $94557121a748c06f$var$_config.enabled ? "%c enabled" : "%c disabled", $94557121a748c06f$var$_config.enabled ? "color:#10b981;font-weight:bold" : "color:#ef4444;font-weight:bold");
        console.log("localStorage key:", $94557121a748c06f$var$LS_KEY);
        console.table(categoryRows);
        if (fileRows.length) {
          console.log("File overrides:");
          console.table(fileRows);
        } else console.log("File overrides: none (all files active)");
        console.groupEnd();
      },
      reset() {
        localStorage.removeItem($94557121a748c06f$var$LS_KEY);
        $94557121a748c06f$var$_config = $94557121a748c06f$var$defaultConfig();
        console.log("%c[DEBUG] Settings cleared from localStorage.", "color:#f59e0b;font-weight:bold");
      },
      help() {
        console.group("%c[DEBUG] Available commands", "color:#6366f1;font-weight:bold");
        console.log([ "__debug.start()               — enable all logging", "__debug.stop()                — disable all logging", "__debug.status()              — show current config", '__debug.enable("category")    — enable a category', '__debug.disable("category")   — disable a category', `__debug.enable("…")           — categories: ${$94557121a748c06f$var$CATEGORIES.join(", ")}`, '__debug.enableFile("file")    — un-exclude a file', '__debug.disableFile("file")   — exclude a file from output', "__debug.reset()               — clear all settings from localStorage", "__debug.help()                — show this help" ].join("\n"));
        console.groupEnd();
      }
    };
  });
  function $66431e48c631c180$var$resolveUrl(url) {
    const resolved = new URL(url, window.location.origin);
    return resolved;
  }
  function $66431e48c631c180$var$captureFocusKey(element) {
    if (!element || typeof element.getAttribute !== "function") return null;
    const escapeValue = value => {
      const stringValue = String(value ?? "");
      if (window.CSS?.escape) return window.CSS.escape(stringValue);
      return stringValue.replace(/["\\]/g, "\\$&");
    };
    if (element.id) return `#${escapeValue(element.id)}`;
    const existingKey = element.getAttribute("data-focus-key");
    if (existingKey) return `[data-focus-key="${escapeValue(existingKey)}"]`;
    const key = window.crypto?.randomUUID?.() || `focus-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    element.setAttribute("data-focus-key", key);
    return `[data-focus-key="${escapeValue(key)}"]`;
  }
  function $66431e48c631c180$var$cleanSourceValue(value) {
    if (value === undefined || value === null) return null;
    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
  }
  function $66431e48c631c180$export$b0deb8d5e24b9a1d(source, {context: context} = {}) {
    const sourceObject = source && typeof source === "object" ? source : {};
    const sourceType = $66431e48c631c180$var$cleanSourceValue(sourceObject.type) || $66431e48c631c180$var$cleanSourceValue(context) || "unknown";
    const sourceId = $66431e48c631c180$var$cleanSourceValue(sourceObject.id) || $66431e48c631c180$var$cleanSourceValue(sourceObject.formId) || $66431e48c631c180$var$cleanSourceValue(sourceObject.triggerId) || null;
    const sourceContext = $66431e48c631c180$var$cleanSourceValue(sourceObject.context) || $66431e48c631c180$var$cleanSourceValue(context) || null;
    return {
      ...sourceObject,
      type: sourceType,
      id: sourceId,
      context: sourceContext
    };
  }
  function $66431e48c631c180$export$ea0028659a60c263({modalElement: modalElement, modalId: modalId, source: source}) {
    if (!modalElement || !source) return;
    const serialized = JSON.stringify(source);
    modalElement.dataset.modalSourceJson = serialized;
    modalElement.dataset.modalSourceType = source.type;
    if (source.id) modalElement.dataset.modalSourceId = source.id; else delete modalElement.dataset.modalSourceId;
    if (source.context) modalElement.dataset.modalSourceContext = source.context; else delete modalElement.dataset.modalSourceContext;
    const lockerContainer = document.querySelector(`[data-locker-container="${modalId}"]`);
    if (!lockerContainer) return;
    lockerContainer.dataset.modalSourceJson = serialized;
    lockerContainer.dataset.modalSourceType = source.type;
    if (source.id) lockerContainer.dataset.modalSourceId = source.id; else delete lockerContainer.dataset.modalSourceId;
    if (source.context) lockerContainer.dataset.modalSourceContext = source.context; else delete lockerContainer.dataset.modalSourceContext;
  }
  function $66431e48c631c180$export$2a22a00258e19e05(baseUrl, {view: view, params: params = {}} = {}) {
    const url = $66431e48c631c180$var$resolveUrl(baseUrl);
    if (view) url.searchParams.set("view", view);
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      url.searchParams.set(key, String(value));
    });
    return url;
  }
  function $66431e48c631c180$export$2d7e6ced278df5e0(url, {view: view} = {}) {
    const parsed = $66431e48c631c180$var$resolveUrl(url);
    const handle = parsed.pathname.split("/").filter(Boolean).pop();
    const activeView = view || parsed.searchParams.get("view");
    return `Modal-${handle}${activeView ? `-${activeView}` : ""}`;
  }
  function $66431e48c631c180$export$b0282b826a38aa22() {
    return document.querySelector("[data-locker]:checked:not(#Cart)");
  }
  function $66431e48c631c180$export$3d270549521cfe37() {
    const openLocker = $66431e48c631c180$export$b0282b826a38aa22();
    if (openLocker?.checked) openLocker.click();
    return openLocker;
  }
  async function $66431e48c631c180$export$1b77a40e1d770f93({url: url, modalId: modalId}) {
    const requestUrl = $66431e48c631c180$var$resolveUrl(url);
    const id = modalId || $66431e48c631c180$export$2d7e6ced278df5e0(requestUrl);
    const startedAt = performance.now();
    const existing = document.getElementById(id);
    if (existing) return {
      modalElement: existing,
      modalId: id,
      loaded: false,
      url: requestUrl
    };
    const response = await fetch(requestUrl);
    if (!response.ok) throw new Error(`[modal-loader] Failed to fetch modal content: ${requestUrl}`);
    const html = await response.text();
    document.body.insertAdjacentHTML("beforeend", html);
    window.dispatchEvent(new CustomEvent("locker_add", {
      detail: id
    }));
    const inserted = document.getElementById(id);
    if (!inserted) throw new Error(`[modal-loader] Modal input "${id}" not found after load`);
    return {
      modalElement: inserted,
      modalId: id,
      loaded: true,
      url: requestUrl
    };
  }
  function $66431e48c631c180$export$96975b969ebc976d(modalElement, {strategy: strategy = "replace"} = {}) {
    if (!modalElement) return;
    if (document.documentElement.dataset.lockerTransitioning === "true") return;
    const openerFocusKey = $66431e48c631c180$var$captureFocusKey(document.activeElement);
    if (openerFocusKey) modalElement.dataset.lockerOpenerFocusKey = openerFocusKey;
    if (strategy === "replace") {
      document.documentElement.dataset.lockerSuppressFocusRestore = "true";
      $66431e48c631c180$export$3d270549521cfe37();
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modalElement.click();
        delete document.documentElement.dataset.lockerSuppressFocusRestore;
      });
    });
  }
  async function $66431e48c631c180$export$d818ec114cd1aefe({baseUrl: baseUrl, view: view, params: params = {}, strategy: strategy = "replace", source: source = null} = {}) {
    const url = $66431e48c631c180$export$2a22a00258e19e05(baseUrl, {
      view: view,
      params: params
    });
    const modalId = $66431e48c631c180$export$2d7e6ced278df5e0(url, {
      view: view
    });
    const {modalElement: modalElement} = await $66431e48c631c180$export$1b77a40e1d770f93({
      url: url,
      modalId: modalId
    });
    $66431e48c631c180$export$ea0028659a60c263({
      modalElement: modalElement,
      modalId: modalId,
      source: source
    });
    $66431e48c631c180$export$96975b969ebc976d(modalElement, {
      strategy: strategy
    });
    return {
      url: url,
      modalId: modalId,
      modalElement: modalElement
    };
  }
  var $9e4lR = parcelRequire("9e4lR");
  const $9ba25b5a4c87c56f$export$c4a8a39c94db4fa4 = () => {
    window.MBF = window.MBF || {};
    if (window.MBF.modalOrchestratorInitialised) return;
    window.MBF.modalOrchestratorInitialised = true;
    window.addEventListener((0, $9e4lR.MODAL_OPEN_REQUEST_EVENT), async event => {
      const {requestId: requestId, baseUrl: baseUrl, view: view, params: params = {}, strategy: strategy = "replace", context: context, source: sourcePayload} = event.detail || {};
      if (!baseUrl) return;
      const source = (0, $66431e48c631c180$export$b0deb8d5e24b9a1d)(sourcePayload, {
        context: context
      });
      try {
        const {url: url, modalId: modalId} = await (0, $66431e48c631c180$export$d818ec114cd1aefe)({
          baseUrl: baseUrl,
          view: view,
          params: params,
          strategy: strategy,
          source: source
        });
        window.dispatchEvent(new CustomEvent((0, $9e4lR.MODAL_OPENED_EVENT), {
          detail: {
            requestId: requestId,
            modalId: modalId,
            url: url.toString(),
            view: view,
            context: context,
            strategy: strategy,
            source: source
          }
        }));
      } catch (error) {
        console.warn(error);
        window.dispatchEvent(new CustomEvent((0, $9e4lR.MODAL_OPEN_FAILED_EVENT), {
          detail: {
            requestId: requestId,
            baseUrl: baseUrl,
            view: view,
            params: params,
            strategy: strategy,
            context: context,
            source: source,
            error: error
          }
        }));
      }
    });
  };
  class $4648aab518e4359b$export$2e2bcd8739ae039 {
    constructor() {
      this._queue = [];
      this._processing = false;
    }
    add(input, opts = {}) {
      const controller = new AbortController;
      if (opts.signal) opts.signal.addEventListener("abort", () => controller.abort(), {
        once: true
      });
      const signal = controller.signal;
      const form = input instanceof HTMLFormElement ? input : null;
      const data = form ? this._parseForm(form) : input;
      this._dispatch(document, "cart:loading", {
        loading: true,
        form: form,
        action: "add"
      });
      return this._enqueue(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data),
        signal: signal
      }).then(cart => {
        const json = form?.querySelector('[type="application/json"]');
        let product = null;
        if (json) {
          product = JSON.parse(json.textContent);
          if (!product.url) product.url = `https://${location.host}/products/${product.handle}`;
        }
        this._dispatch(window, "cart:added", {
          item: cart,
          product: product,
          form: form
        });
        this._dispatch(document, "cart:updated", {
          cart: cart
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: form,
          action: "add"
        });
        opts.callback?.(null, cart);
        return cart;
      }).catch(err => {
        if (err.name === "AbortError") return;
        this._dispatch(document, "cart:error", {
          error: err,
          message: err.description || err.message,
          form: form
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: form,
          action: "add"
        });
        opts.callback?.(err, null);
        throw err;
      });
    }
    change(data, opts = {}) {
      this._dispatch(document, "cart:loading", {
        loading: true,
        form: null,
        action: "change"
      });
      return this._enqueue(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(cart => {
        this._dispatch(document, "cart:updated", {
          cart: cart
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: null,
          action: "change"
        });
        opts.callback?.(null, cart);
        return cart;
      }).catch(err => {
        this._dispatch(document, "cart:error", {
          error: err,
          message: err.description || err.message,
          form: null
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: null,
          action: "change"
        });
        opts.callback?.(err, null);
        throw err;
      });
    }
    update(data, opts = {}) {
      this._dispatch(document, "cart:loading", {
        loading: true,
        form: null,
        action: "update"
      });
      return this._enqueue(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(cart => {
        this._dispatch(document, "cart:updated", {
          cart: cart
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: null,
          action: "update"
        });
        opts.callback?.(null, cart);
        return cart;
      }).catch(err => {
        this._dispatch(document, "cart:error", {
          error: err,
          message: err.description || err.message,
          form: null
        });
        this._dispatch(document, "cart:loading", {
          loading: false,
          form: null,
          action: "update"
        });
        opts.callback?.(err, null);
        throw err;
      });
    }
    get(opts = {}) {
      return this._enqueue(`${window.Shopify.routes.root}cart.js`, {
        method: "GET",
        headers: {
          Accept: "application/json"
        },
        signal: opts.signal
      });
    }
    _drainQueue() {
      const stub = window.MBF?.cart;
      const pending = stub?.queue || [];
      if (stub) stub.action = (method, ...args) => this[method]?.(...args);
      pending.forEach(({method: method, args: args}) => {
        if (typeof this[method] === "function") this[method](...args);
      });
    }
    _enqueue(url, fetchOpts) {
      const fp = `${fetchOpts.method}:${url}:${fetchOpts.body ?? ""}`;
      const isAddRequest = url.includes("cart/add.js");
      if (!isAddRequest && this._queue.some(t => t.fp === fp)) return Promise.reject(new Error("[cart] Duplicate request dropped"));
      return new Promise((resolve, reject) => {
        this._queue.push({
          fp: fp,
          run: () => fetch(url, fetchOpts).then(async res => {
            if (!res.ok) {
              const err = await res.json().catch(() => null);
              const description = err?.description;
              const message = typeof description === "string" && description || typeof err?.message === "string" && err.message || `HTTP ${res.status}`;
              const errors = err?.errors || (description && typeof description === "object" ? description : null);
              const error = new Error(message);
              error.status = res.status;
              error.description = description;
              error.errors = errors;
              error.payload = err;
              throw error;
            }
            return res.json();
          }),
          resolve: resolve,
          reject: reject
        });
        this._processQueue();
      });
    }
    async _processQueue() {
      if (this._processing || !this._queue.length) return;
      this._processing = true;
      while (this._queue.length) {
        const task = this._queue[0];
        try {
          task.resolve(await task.run());
        } catch (err) {
          task.reject(err);
        }
        this._queue.shift();
      }
      this._processing = false;
    }
    _parseForm(form) {
      const formData = new FormData(form);
      const purchaseOption = form.querySelector('[name="purchase_option"]:checked');
      if (purchaseOption?.value === "once") formData.delete("selling_plan");
      if (formData.get("properties[__shopify_send_gift_card_to_recipient]") === "false") formData.delete("properties[__shopify_send_gift_card_to_recipient]");
      const json = {};
      for (const [key, value] of formData.entries()) {
        const keys = key.split(/[\[\]]+/).filter(k => k);
        let current = json;
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i];
          if (i === keys.length - 1) {
            if (Object.prototype.hasOwnProperty.call(current, k)) {
              if (Array.isArray(current[k])) current[k].push(value); else current[k] = [ current[k], value ];
            } else current[k] = value;
          } else {
            const nextKey = keys[i + 1];
            if (!current[k]) current[k] = /^\d+$/.test(nextKey) ? [] : {};
            current = current[k];
          }
        }
      }
      return json;
    }
    _dispatch(target, event, detail) {
      target.dispatchEvent(new CustomEvent(event, {
        bubbles: true,
        detail: detail
      }));
    }
  }
  let $9a73a619dcb4ee12$var$initialised = false;
  function $9a73a619dcb4ee12$export$8b15e3b47cc9809() {
    if ($9a73a619dcb4ee12$var$initialised) return;
    $9a73a619dcb4ee12$var$initialised = true;
    let savedStates = new Map;
    let activeButtons = [];
    let revertTimer = null;
    function cancelRevert() {
      if (revertTimer) {
        clearTimeout(revertTimer);
        revertTimer = null;
      }
    }
    function findButtons(form) {
      return [ ...form?.querySelectorAll("[data-atc]") ?? [] ];
    }
    function snapshotButtons(buttons) {
      savedStates = new Map;
      buttons.forEach(btn => {
        savedStates.set(btn, {
          innerHTML: btn.innerHTML,
          disabled: btn.disabled
        });
      });
    }
    function setButtonText(btn, text) {
      const textEl = btn.querySelector("[data-atc-text]");
      const priceEl = btn.querySelector("[data-atc-price]");
      if (textEl) textEl.textContent = text; else btn.innerHTML = text;
      if (priceEl) priceEl.style.display = "none";
    }
    function resetButtons(buttons, states) {
      buttons.forEach(btn => {
        const saved = states.get(btn);
        if (saved) {
          btn.innerHTML = saved.innerHTML;
          btn.disabled = saved.disabled;
        } else {
          const textEl = btn.querySelector("[data-atc-text]");
          if (textEl) textEl.textContent = window.MBF?.strings?.addToCart || "Translation missing: en.product.add_to_cart"; else btn.innerHTML = window.MBF?.strings?.addToCart || "Translation missing: en.product.add_to_cart";
          btn.disabled = false;
        }
      });
    }
    function setFormLoading(form, loading) {
      if (!form) return;
      const container = form.closest(".product-form, .product-form-sticky");
      container?.classList.toggle("loading", loading);
    }
    function handleNonAddLoading(loading) {
      document.dispatchEvent(new CustomEvent(loading ? "spinner:show" : "spinner:hide", {
        bubbles: true,
        detail: {
          source: "cart"
        }
      }));
    }
    document.addEventListener("cart:loading", e => {
      const {loading: loading, form: form, action: action} = e.detail;
      if (action !== "add") {
        handleNonAddLoading(loading);
        return;
      }
      if (loading) {
        cancelRevert();
        activeButtons = findButtons(form);
        snapshotButtons(activeButtons);
        activeButtons.forEach(btn => {
          setButtonText(btn, window.MBF?.strings?.adding || "Translation missing: en.product.adding");
          btn.disabled = true;
        });
        document.dispatchEvent(new CustomEvent("spinner:show", {
          bubbles: true,
          detail: {
            source: "cart"
          }
        }));
        setFormLoading(form, true);
      } else {
        document.dispatchEvent(new CustomEvent("spinner:hide", {
          bubbles: true,
          detail: {
            source: "cart"
          }
        }));
        setFormLoading(form, false);
      }
    });
    window.addEventListener("cart:added", e => {
      const {form: form} = e.detail;
      const buttons = form ? findButtons(form) : activeButtons;
      if (!buttons.length) return;
      cancelRevert();
      buttons.forEach(btn => {
        setButtonText(btn, window.MBF?.strings?.added || "Translation missing: en.product.added");
        btn.disabled = true;
      });
      const snapshot = savedStates;
      revertTimer = setTimeout(() => {
        revertTimer = null;
        resetButtons(buttons, snapshot);
      }, 2e3);
    });
    document.addEventListener("cart:error", e => {
      const {form: form} = e.detail;
      const buttons = form ? findButtons(form) : activeButtons;
      if (!buttons.length) return;
      buttons.forEach(btn => {
        setButtonText(btn, window.MBF?.strings?.error || "Error");
        btn.disabled = true;
      });
      const snapshot = savedStates;
      setTimeout(() => resetButtons(buttons, snapshot), 2e3);
    });
  }
  var $7bS3h = parcelRequire("7bS3h");
  function $dc3a8234724f357a$export$2e2bcd8739ae039(image, size = "master") {
    if (!image) return "";
    let resolved = image;
    if (!resolved.match(/^http(s?):/i)) resolved = `https:${resolved}`;
    return resolved.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".").replace(/\.(jpg|png|gif|jpeg)/g, extension => "_" + size + extension);
  }
  let $3dd422164d2c172f$var$initialised = false;
  function $3dd422164d2c172f$export$4bb4d890bddbff23() {
    if ($3dd422164d2c172f$var$initialised) return;
    $3dd422164d2c172f$var$initialised = true;
    window.addEventListener("cart:added", e => {
      const {item: item, product: product} = e.detail;
      if (!product) return;
      if (!window.Shopify?.customerPrivacy?.userCanBeTracked()) return;
      $3dd422164d2c172f$var$_trackKlaviyo(item, product);
      $3dd422164d2c172f$var$_trackGA4(item, product);
    });
  }
  function $3dd422164d2c172f$var$_trackKlaviyo(item, product) {
    try {
      const sizedImage = (0, $dc3a8234724f357a$export$2e2bcd8739ae039)(product.featured_image, "1024x");
      window._learnq = window._learnq || [];
      window._learnq.push([ "track", "Added to Cart", {
        Name: product.title,
        Title: product.title,
        ItemId: product.id,
        ProductId: product.id,
        Price: product.price / 100,
        CompareAtPrice: product.compare_at_price_max / 100,
        Categories: "",
        ImageUrl: sizedImage || "",
        Url: product.url,
        Metadata: {
          Brand: product.vendor,
          Price: product.price / 100,
          CompareAtPrice: product.compare_at_price / 100
        }
      } ]);
    } catch (e) {
      console.warn("[cart] Klaviyo tracking failed", e);
    }
  }
  function $3dd422164d2c172f$var$_trackGA4(item, product) {
    try {
      const sizedImage = (0, $dc3a8234724f357a$export$2e2bcd8739ae039)(product.featured_image, "1024x");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [ {
            item_id: item?.sku || product.id,
            item_variant: item?.variant_id || "",
            item_name: product.title,
            price: (0, $7bS3h.default)(product.price),
            item_brand: product.vendor,
            item_category: product.type,
            item_list_name: "",
            description: "",
            imageURL: sizedImage || "",
            productURL: product.url
          } ]
        }
      });
    } catch (e) {
      console.warn("[cart] GA4 tracking failed", e);
    }
  }
  function $3d587baaa7c7c73b$export$e838c4b04241f74() {
    window.MBF = window.MBF || {};
    const cart = new (0, $4648aab518e4359b$export$2e2bcd8739ae039);
    window.MBF.cart = cart;
    cart._drainQueue();
  }
  var $gjV2B = parcelRequire("gjV2B");
  const $80097fcffb74f07b$export$ff7eafc1f9e0360c = value => {
    const stringValue = String(value ?? "");
    if (window.CSS?.escape) return window.CSS.escape(stringValue);
    return stringValue.replace(/["\\]/g, "\\$&");
  };
  const $80097fcffb74f07b$export$4c063cf1350e6fed = element => Boolean(element && typeof element.focus === "function" && !element.hasAttribute("disabled") && element.getAttribute("aria-hidden") !== "true");
  const $80097fcffb74f07b$export$19de954e0a4e25ea = () => Array.from(document.querySelectorAll("[data-locker]"));
  const $80097fcffb74f07b$export$34c0397c788e698b = lockerId => document.querySelector(`[data-locker-container="${$80097fcffb74f07b$export$ff7eafc1f9e0360c(lockerId)}"]`);
  const $80097fcffb74f07b$export$a0271a4c3bcb9cb1 = element => {
    if (!element || typeof element.getAttribute !== "function") return null;
    if (element.id) return `#${$80097fcffb74f07b$export$ff7eafc1f9e0360c(element.id)}`;
    const existingFocusKey = element.getAttribute("data-focus-key");
    if (existingFocusKey) return `[data-focus-key="${$80097fcffb74f07b$export$ff7eafc1f9e0360c(existingFocusKey)}"]`;
    const generatedKey = window.crypto?.randomUUID?.() || `focus-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    element.setAttribute("data-focus-key", generatedKey);
    return `[data-focus-key="${$80097fcffb74f07b$export$ff7eafc1f9e0360c(generatedKey)}"]`;
  };
  const $10fc35003d9dd4ff$export$45b89e64374e40f9 = (currentBaseUnderlayEl, baseUnderlayZIndex) => {
    if (currentBaseUnderlayEl?.isConnected) return currentBaseUnderlayEl;
    const existing = document.querySelector("[data-locker-base-underlay]");
    if (existing) return existing;
    const underlay = document.createElement("div");
    underlay.setAttribute("data-locker-base-underlay", "");
    underlay.className = "locker-base-underlay";
    underlay.style.zIndex = String(baseUnderlayZIndex);
    document.body.appendChild(underlay);
    return underlay;
  };
  const $10fc35003d9dd4ff$export$b52316205bae27ab = (baseUnderlayEl, isActive) => {
    if (!baseUnderlayEl) return;
    baseUnderlayEl.dataset.active = isActive ? "true" : "false";
  };
  const $10fc35003d9dd4ff$export$554450921fae7cf5 = ({stackEntries: stackEntries, layerZIndexBase: layerZIndexBase, getLockerContainer: getLockerContainer}) => {
    const stackSize = stackEntries.length;
    const topEntry = stackEntries[stackSize - 1] || null;
    const allLockers = (0, $80097fcffb74f07b$export$19de954e0a4e25ea)();
    allLockers.forEach(locker => {
      if (!locker.id) return;
      const container = getLockerContainer(locker.id);
      if (!container) return;
      const stackIndex = stackEntries.findIndex(entry => entry.lockerId === locker.id);
      const isActive = stackIndex !== -1;
      const isTop = Boolean(topEntry && topEntry.lockerId === locker.id);
      container.dataset.layerActive = isActive ? "true" : "false";
      if (isActive) {
        container.dataset.layerTop = isTop ? "true" : "false";
        container.dataset.layerIndex = String(stackIndex);
        container.dataset.layerDepth = String(stackSize);
        container.dataset.layerOverlay = isTop ? "false" : "true";
        container.style.setProperty("--locker-layer-index", String(stackIndex));
        container.style.zIndex = String(layerZIndexBase + stackIndex);
      } else {
        delete container.dataset.layerTop;
        delete container.dataset.layerIndex;
        delete container.dataset.layerDepth;
        delete container.dataset.layerOverlay;
        container.style.removeProperty("--locker-layer-index");
        container.style.removeProperty("z-index");
      }
      container.toggleAttribute("inert", !isTop);
    });
  };
  const $03adcc2e39e0bf82$export$52e6c7c72e88442f = (element, headerSelector) => Boolean(element.matches && (element.matches(headerSelector) || element.closest && element.closest(headerSelector)));
  const $03adcc2e39e0bf82$export$71d607b12fa986c6 = ({elements: elements, lockerContainer: lockerContainer, mainElement: mainElement, sectionSelector: sectionSelector, headerSelector: headerSelector, shouldIncludeHeaders: shouldIncludeHeaders}) => {
    const isLockerInsideMain = mainElement.contains(lockerContainer);
    let elementsToManage = Array.from(elements).filter(element => {
      if ($03adcc2e39e0bf82$export$52e6c7c72e88442f(element, headerSelector)) return shouldIncludeHeaders;
      if (!isLockerInsideMain) return element === mainElement || !mainElement.contains(element) && !element.contains(lockerContainer);
      if (element === mainElement) return false;
      return !element.contains(lockerContainer);
    });
    const parentElement = lockerContainer.closest(sectionSelector);
    if (parentElement) {
      const siblings = Array.from(parentElement.children).filter(child => child !== lockerContainer && (!$03adcc2e39e0bf82$export$52e6c7c72e88442f(child, headerSelector) || shouldIncludeHeaders) && !child.contains(lockerContainer) && child.tagName !== "SCRIPT" && child.tagName !== "STYLE");
      const combined = new Set([ ...elementsToManage, ...siblings ]);
      elementsToManage = Array.from(combined);
    }
    return elementsToManage;
  };
  const $03adcc2e39e0bf82$export$25cf56a7c4191bb0 = managedInertState => {
    managedInertState.forEach((hadInertBefore, element) => {
      if (!hadInertBefore) element.removeAttribute("inert");
    });
    managedInertState.clear();
  };
  const $2c571fdf739a6a58$export$e461d6e8fe5ebcb9 = ({previousStack: previousStack, openOrderCounter: openOrderCounter, getLockerContainer: getLockerContainer, captureFocusKey: captureFocusKey, onWarn: onWarn}) => {
    const checkedLockers = (0, $80097fcffb74f07b$export$19de954e0a4e25ea)().filter(locker => locker.checked && locker.id);
    const checkedIds = new Set(checkedLockers.map(locker => locker.id));
    const previousIds = new Set(previousStack.map(entry => entry.lockerId));
    const remainingEntries = previousStack.filter(entry => checkedIds.has(entry.lockerId)).map(entry => {
      const lockerEl = checkedLockers.find(locker => locker.id === entry.lockerId) || entry.lockerEl || null;
      const containerEl = lockerEl ? getLockerContainer(lockerEl.id) : null;
      return {
        ...entry,
        lockerEl: lockerEl,
        containerEl: containerEl
      };
    });
    const openedEntries = [];
    let nextOpenOrderCounter = openOrderCounter;
    checkedLockers.forEach(locker => {
      if (previousIds.has(locker.id)) return;
      const containerEl = getLockerContainer(locker.id);
      if (!containerEl) {
        onWarn?.(`LockerManager: No container found for locker: ${locker.id}`);
        return;
      }
      const explicitFocusKey = locker.dataset.lockerOpenerFocusKey || null;
      if (explicitFocusKey) delete locker.dataset.lockerOpenerFocusKey;
      const activeFocusKey = explicitFocusKey || captureFocusKey(document.activeElement) || null;
      const entry = {
        lockerId: locker.id,
        lockerEl: locker,
        containerEl: containerEl,
        openedAt: ++nextOpenOrderCounter,
        openerFocusKey: activeFocusKey,
        source: containerEl.dataset.modalSourceType || containerEl.dataset.modalSourceContext || "locker"
      };
      remainingEntries.push(entry);
      openedEntries.push(entry);
    });
    remainingEntries.sort((a, b) => a.openedAt - b.openedAt);
    const closedEntries = previousStack.filter(entry => !remainingEntries.some(next => next.lockerId === entry.lockerId));
    return {
      stackEntries: remainingEntries,
      openedEntries: openedEntries,
      closedEntries: closedEntries,
      openOrderCounter: nextOpenOrderCounter
    };
  };
  const $668d4c6bb8951935$var$LOCKER_OPENED_EVENT = "locker:opened";
  const $668d4c6bb8951935$var$LOCKER_CLOSED_EVENT = "locker:closed";
  const $668d4c6bb8951935$var$LOCKER_STACK_CHANGED_EVENT = "locker:stack-changed";
  const $668d4c6bb8951935$var$LAYER_Z_INDEX_BASE = 9e3;
  const $668d4c6bb8951935$var$BASE_UNDERLAY_Z_INDEX = $668d4c6bb8951935$var$LAYER_Z_INDEX_BASE - 1;
  const $668d4c6bb8951935$var$MAX_RECOMMENDED_LAYER_DEPTH = 3;
  const $668d4c6bb8951935$var$DEFAULT_TRANSITION_LOCK_MS = 350;
  class $668d4c6bb8951935$export$92b09de1ab20357c {
    #elements=new Set;
    #desktopMediaQuery=null;
    #stackEntries=[];
    #openOrderCounter=0;
    #managedInertState=new Map;
    #isTransitioning=false;
    #transitionUnlockTimer=null;
    #baseUnderlayEl=null;
    constructor(mainSelector = "main", sectionSelector = ".shopify-section", modalSelector = ".ajax-modal", headerSelector = "header") {
      this.selectors = {
        mainSelector: mainSelector,
        sectionSelector: sectionSelector,
        modalSelector: modalSelector,
        headerSelector: headerSelector
      };
      this.#desktopMediaQuery = window.matchMedia("(min-width: 1024px)");
      this.init();
    }
    init() {
      this.#baseUnderlayEl = (0, $10fc35003d9dd4ff$export$45b89e64374e40f9)(this.#baseUnderlayEl, $668d4c6bb8951935$var$BASE_UNDERLAY_Z_INDEX);
      this.updateElementsCache();
      this.reconcileStack();
      this.setupEventListeners();
      this.setupMediaQueryListener();
    }
    updateElementsCache() {
      const {mainSelector: mainSelector, sectionSelector: sectionSelector, modalSelector: modalSelector, headerSelector: headerSelector} = this.selectors;
      try {
        const mainElement = document.querySelector(mainSelector);
        const sectionElements = Array.from(document.querySelectorAll(sectionSelector));
        const modalElements = Array.from(document.querySelectorAll(modalSelector));
        const headerElements = Array.from(document.querySelectorAll(headerSelector));
        if (!mainElement) {
          console.warn(`LockerManager: Main element "${mainSelector}" not found.`);
          return;
        }
        this.#elements.clear();
        [ ...sectionElements, ...modalElements, ...headerElements, mainElement ].filter(Boolean).forEach(element => this.#elements.add(element));
      } catch (error) {
        console.error("LockerManager: Error updating elements cache:", error);
      }
    }
    isHeaderElement(element) {
      const {headerSelector: headerSelector} = this.selectors;
      return (0, $03adcc2e39e0bf82$export$52e6c7c72e88442f)(element, headerSelector);
    }
    shouldMakeHeaderInert() {
      return this.#desktopMediaQuery.matches;
    }
    getFilteredElements(lockerContainer, mainElement) {
      const {sectionSelector: sectionSelector} = this.selectors;
      const {headerSelector: headerSelector} = this.selectors;
      return (0, $03adcc2e39e0bf82$export$71d607b12fa986c6)({
        elements: this.#elements,
        lockerContainer: lockerContainer,
        mainElement: mainElement,
        sectionSelector: sectionSelector,
        headerSelector: headerSelector,
        shouldIncludeHeaders: this.shouldMakeHeaderInert()
      });
    }
    #dispatchLockerEvent(type, detail) {
      window.dispatchEvent(new CustomEvent(type, {
        detail: detail
      }));
    }
    #setTransitionLock() {
      this.#isTransitioning = true;
      document.documentElement.dataset.lockerTransitioning = "true";
      if (this.#transitionUnlockTimer) clearTimeout(this.#transitionUnlockTimer);
      this.#transitionUnlockTimer = window.setTimeout(() => {
        this.#isTransitioning = false;
        delete document.documentElement.dataset.lockerTransitioning;
        this.#transitionUnlockTimer = null;
      }, $668d4c6bb8951935$var$DEFAULT_TRANSITION_LOCK_MS);
    }
    #warnOnDeepStack(depth) {
      if (depth <= $668d4c6bb8951935$var$MAX_RECOMMENDED_LAYER_DEPTH) return;
      console.warn(`LockerManager: Deep layer stack detected (${depth}). Consider revising UX flow before exceeding ${$668d4c6bb8951935$var$MAX_RECOMMENDED_LAYER_DEPTH} layers.`);
    }
    #getLockerContainer(lockerId) {
      return (0, $80097fcffb74f07b$export$34c0397c788e698b)(lockerId);
    }
    #getTopEntry() {
      return this.#stackEntries[this.#stackEntries.length - 1] || null;
    }
    #updateBaseUnderlay(isActive) {
      (0, $10fc35003d9dd4ff$export$b52316205bae27ab)(this.#baseUnderlayEl, isActive);
    }
    #handleOutsidePointerDown=event => {
      const topEntry = this.#getTopEntry();
      if (!topEntry?.lockerEl?.checked || !topEntry.containerEl) return;
      if (this.#isTransitioning) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      const topDrawer = topEntry.containerEl.querySelector("[data-drawer]") || topEntry.containerEl;
      if (topDrawer.contains(event.target)) return;
      topEntry.lockerEl.click();
    };
    #clearManagedInert() {
      (0, $03adcc2e39e0bf82$export$25cf56a7c4191bb0)(this.#managedInertState);
    }
    #applyManagedInert(topEntry) {
      this.#clearManagedInert();
      if (!topEntry?.containerEl) return;
      const mainElement = document.querySelector(this.selectors.mainSelector);
      if (!mainElement) return;
      const elementsToManage = this.getFilteredElements(topEntry.containerEl, mainElement);
      elementsToManage.forEach(element => {
        if (!this.#managedInertState.has(element)) this.#managedInertState.set(element, element.hasAttribute("inert"));
        element.setAttribute("inert", "");
      });
    }
    #applyContainerStates() {
      (0, $10fc35003d9dd4ff$export$554450921fae7cf5)({
        stackEntries: this.#stackEntries,
        layerZIndexBase: $668d4c6bb8951935$var$LAYER_Z_INDEX_BASE,
        getLockerContainer: lockerId => this.#getLockerContainer(lockerId)
      });
    }
    #restoreFocusFromEntry(entry) {
      if (!entry?.openerFocusKey) return;
      if (document.documentElement.dataset.lockerSuppressFocusRestore === "true") return;
      requestAnimationFrame(() => {
        const target = document.querySelector(entry.openerFocusKey);
        if ((0, $80097fcffb74f07b$export$4c063cf1350e6fed)(target)) {
          target.focus();
          return;
        }
        const nextTop = this.#getTopEntry();
        const fallbackTarget = nextTop?.containerEl?.querySelector("[data-close], label[for], button, [href], input") || null;
        if ((0, $80097fcffb74f07b$export$4c063cf1350e6fed)(fallbackTarget)) fallbackTarget.focus();
      });
    }
    reconcileStack({changedLocker: changedLocker = null} = {}) {
      this.updateElementsCache();
      const previousStack = [ ...this.#stackEntries ];
      const {stackEntries: stackEntries, openedEntries: openedEntries, closedEntries: closedEntries, openOrderCounter: openOrderCounter} = (0, 
      $2c571fdf739a6a58$export$e461d6e8fe5ebcb9)({
        previousStack: previousStack,
        openOrderCounter: this.#openOrderCounter,
        getLockerContainer: lockerId => this.#getLockerContainer(lockerId),
        captureFocusKey: $80097fcffb74f07b$export$a0271a4c3bcb9cb1,
        onWarn: message => console.warn(message)
      });
      this.#stackEntries = stackEntries;
      this.#openOrderCounter = openOrderCounter;
      this.#warnOnDeepStack(this.#stackEntries.length);
      this.#applyContainerStates();
      this.#applyManagedInert(this.#getTopEntry());
      openedEntries.forEach(entry => {
        const index = this.#stackEntries.findIndex(item => item.lockerId === entry.lockerId);
        this.#dispatchLockerEvent($668d4c6bb8951935$var$LOCKER_OPENED_EVENT, {
          lockerId: entry.lockerId,
          index: index,
          depth: this.#stackEntries.length,
          source: entry.source,
          openerFocusKey: entry.openerFocusKey
        });
      });
      closedEntries.forEach(entry => {
        const wasTop = previousStack[previousStack.length - 1]?.lockerId === entry.lockerId;
        this.#dispatchLockerEvent($668d4c6bb8951935$var$LOCKER_CLOSED_EVENT, {
          lockerId: entry.lockerId,
          depthBeforeClose: previousStack.length,
          source: entry.source || "locker",
          wasTop: wasTop
        });
        if (wasTop) this.#restoreFocusFromEntry(entry);
      });
      const topLockerId = this.#getTopEntry()?.lockerId || null;
      this.#dispatchLockerEvent($668d4c6bb8951935$var$LOCKER_STACK_CHANGED_EVENT, {
        stack: this.#stackEntries.map(entry => entry.lockerId),
        topLockerId: topLockerId,
        depth: this.#stackEntries.length,
        changedLockerId: changedLocker?.id || null,
        isTransitioning: this.#isTransitioning
      });
      this.#updateBaseUnderlay(this.#stackEntries.length > 0);
    }
    #handleMediaQueryChange=() => {
      if (this.#stackEntries.length === 0) return;
      this.#applyManagedInert(this.#getTopEntry());
    };
    setupMediaQueryListener() {
      this.#desktopMediaQuery.addEventListener("change", this.#handleMediaQueryChange);
    }
    setupEventListeners() {
      document.addEventListener("pointerdown", this.#handleOutsidePointerDown, true);
      document.addEventListener("change", event => {
        const locker = event.target?.closest?.("[data-locker]");
        if (!locker) return;
        this.#setTransitionLock();
        this.reconcileStack({
          changedLocker: locker
        });
      });
      window.addEventListener("locker_add", event => {
        const newLockerId = event.detail;
        if (!newLockerId) {
          console.warn('LockerManager: "locker_add" event triggered without locker ID in detail.');
          return;
        }
        const newLocker = document.querySelector(`#${(0, $80097fcffb74f07b$export$ff7eafc1f9e0360c)(newLockerId)}`);
        if (!newLocker) {
          console.warn(`LockerManager: Could not find new locker with ID: ${newLockerId}`);
          return;
        }
        this.reconcileStack({
          changedLocker: newLocker
        });
      });
    }
    destroy() {
      if (this.#desktopMediaQuery) this.#desktopMediaQuery.removeEventListener("change", this.#handleMediaQueryChange);
      document.removeEventListener("pointerdown", this.#handleOutsidePointerDown, true);
      if (this.#transitionUnlockTimer) {
        clearTimeout(this.#transitionUnlockTimer);
        this.#transitionUnlockTimer = null;
      }
      delete document.documentElement.dataset.lockerTransitioning;
      this.#updateBaseUnderlay(false);
      this.#clearManagedInert();
      this.#elements.clear();
      this.#stackEntries = [];
    }
  }
  var $668d4c6bb8951935$export$2e2bcd8739ae039 = $668d4c6bb8951935$export$92b09de1ab20357c;
  function $2882ac8c1776fa7b$export$3a62f099a1df6abf() {
    const initCloser = () => {
      const handleEscape = (0, $gjV2B.debounce)(event => {
        if (event.key === "Escape") {
          document.querySelectorAll("details").forEach(el => !el.open);
          const topLayerContainer = document.querySelector('[data-locker-container][data-layer-top="true"]');
          const topLockerId = topLayerContainer?.getAttribute("data-locker-container") || null;
          const topLocker = topLockerId ? document.getElementById(topLockerId) : null;
          if (topLocker?.checked) {
            topLocker.click();
            return;
          }
          const fallbackOpenLocker = document.querySelector("[data-locker]:checked");
          if (fallbackOpenLocker) fallbackOpenLocker.click();
        }
      });
      document.addEventListener("keydown", handleEscape, {
        passive: true
      });
    };
    const handleLabelKeyboardInteraction = () => {
      document.addEventListener("keydown", event => {
        const activeElement = document.activeElement;
        if ((event.key === "Enter" || event.code === "Space") && activeElement.tagName === "LABEL" && activeElement.htmlFor) {
          const targetInput = document.getElementById(activeElement.htmlFor);
          if (targetInput && (targetInput.type === "checkbox" || targetInput.type === "radio")) {
            activeElement.click();
            targetInput.click();
            event.preventDefault();
          }
        }
      });
    };
    const handleButtonKeydown = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        const element = event.target;
        element.classList.add("active");
        setTimeout(() => {
          element.classList.remove("active");
        }, 150);
        element.click();
      }
    };
    const initButtonRoleAccessibility = () => {
      const makeButtonAccessible = element => {
        if (!element.hasAttribute("tabindex")) element.tabIndex = 0;
        if (!element.hasAttribute("data-keyboard-enabled")) {
          element.addEventListener("keydown", handleButtonKeydown);
          element.setAttribute("data-keyboard-enabled", "true");
        }
      };
      document.querySelectorAll('[role="button"]').forEach(makeButtonAccessible);
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.getAttribute("role") === "button") makeButtonAccessible(node);
              const buttonElements = node.querySelectorAll ? node.querySelectorAll('[role="button"]') : [];
              buttonElements.forEach(makeButtonAccessible);
            }
          });
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      window._buttonRoleObserver = observer;
    };
    const initLabelKeyboardAccessibility = () => {
      const makeLabelAccessible = label => {
        if (label.htmlFor && !label.hasAttribute("tabindex")) label.tabIndex = 0;
      };
      document.querySelectorAll("label[for]").forEach(makeLabelAccessible);
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === "LABEL" && node.htmlFor) makeLabelAccessible(node);
              const labels = node.querySelectorAll ? node.querySelectorAll("label[for]") : [];
              labels.forEach(makeLabelAccessible);
            }
          });
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };
    const initScrollLock = () => {
      const updateScrollLockState = () => {
        const hasOpenLocker = Boolean(document.querySelector("[data-locker]:checked"));
        document.documentElement.classList.toggle("lock-scroll", hasOpenLocker);
      };
      const setupLocker = locker => {
        locker.addEventListener("change", () => {
          updateScrollLockState();
        });
      };
      document.querySelectorAll("[data-locker]").forEach(setupLocker);
      window.addEventListener("locker_add", event => {
        const newLockerId = event.detail;
        if (newLockerId) {
          const newLocker = document.querySelector(`#${newLockerId}`);
          if (newLocker) {
            setupLocker(newLocker);
            updateScrollLockState();
          }
        }
      });
      updateScrollLockState();
    };
    const trackRecentlyViewed = () => {
      const key = "recentlyViewed";
      const recentlyViewed = JSON.parse(localStorage.getItem(key)) || [];
      const match = location.href.match(/\/products\/([^\?#]+)/);
      const productId = match?.[1];
      if (productId && !recentlyViewed.includes(productId)) {
        const updatedList = [ productId, ...recentlyViewed ].slice(0, 8);
        localStorage.setItem(key, JSON.stringify(updatedList));
        window.Shopify = {
          ...window.Shopify,
          recentlyViewed: updatedList
        };
      }
    };
    const updateVisualViewport = () => {
      const root = document.documentElement;
      const header = document.querySelector("[data-header]") || document.querySelector("header");
      const siteHeader = header?.querySelector("site-header");
      const announcementBar = document.querySelector("[data-announcement]") || document.querySelector(".section-announcement");
      const headerHeight = Math.round(siteHeader?.getBoundingClientRect().height) || 0;
      const announcementRect = announcementBar?.getBoundingClientRect();
      const announcementHeight = Math.round(announcementRect?.height) || 0;
      let visibleAnnouncementHeight = 0;
      if (announcementRect && announcementRect.bottom > 0) visibleAnnouncementHeight = Math.max(0, Math.min(announcementHeight, announcementRect.bottom));
      root.style.setProperty("--visual-viewport", `${window.visualViewport?.height || window.innerHeight}px`);
      root.style.setProperty("--header-height", `${headerHeight}px`);
      root.style.setProperty("--announcement-height", `${announcementHeight}px`);
      document.documentElement.style.setProperty("--header-full-height", `${Math.round((headerHeight || 0) + visibleAnnouncementHeight)}px`);
    };
    const scrollTrigger = () => {
      const trigger = document.querySelector("[data-scroll-trigger]");
      if (trigger) {
        const observer = new IntersectionObserver(entries => {
          entries[0].isIntersecting ? document.body.classList.remove("is-scrolled") : document.body.classList.add("is-scrolled");
          window.dispatchEvent(new CustomEvent("scroll-trigger", {
            bubbles: true,
            detail: {
              isScrolled: !entries[0].isIntersecting
            }
          }));
        });
        observer.observe(trigger);
      }
    };
    const checkLocation = () => {
      const geoPopupData = localStorage.getItem("GEO_POPUP_SHOWN");
      if (geoPopupData) {
        const {timestamp: timestamp} = JSON.parse(geoPopupData);
        const thirtyMinutes = 18e5;
        if (Date.now() - timestamp < thirtyMinutes) return;
      }
      window.Geo.perform(country => {
        if (country.handle !== window.Shopify?.country) {
          const modal = document.getElementById("Modal-Localization")?.closest(".modal"), modalToggle = document.getElementById("Modal-Localization"), select = modal.querySelector('[name="country_code"]');
          if (!select || !modal) return;
          select.value = country.handle;
          select.dispatchEvent(new Event("change", {
            bubbles: true
          }));
          if (!modalToggle.checked) modalToggle.click();
          document.body.classList.add("attentive-hide");
          localStorage.setItem("GEO_POPUP_SHOWN", JSON.stringify({
            timestamp: Date.now()
          }));
        }
      });
    };
    const handleSubscriptionError = () => {
      const url = window.location.href;
      if (url.includes("form_type=customer")) {
        const id = url.split("#").pop() || "footer";
        const form = document.querySelector(`#${id}`) || document.querySelector('footer[action^="/contact"]');
        if (form) {
          const input = form.querySelector('[type="email"]');
          if (input && input.value.length > 0) {
            const errorMsg = document.createElement("p");
            errorMsg.classList.add("mt-sm", "text-terracotta");
            errorMsg.innerText = window.MBF?.strings?.newsletter?.existing || "You are already subscribed.";
            form.appendChild(errorMsg);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "newsletter_signup",
              form_action: "submit-failure",
              error_id: window.MBF?.strings?.newsletter?.existing
            });
          }
        }
      }
    };
    const cleanup = () => {
      if (window._buttonRoleObserver) {
        window._buttonRoleObserver.disconnect();
        delete window._buttonRoleObserver;
      }
    };
    const init = () => {
      new (0, $668d4c6bb8951935$export$92b09de1ab20357c);
      initCloser();
      handleLabelKeyboardInteraction();
      initLabelKeyboardAccessibility();
      initButtonRoleAccessibility();
      initScrollLock();
      scrollTrigger();
      trackRecentlyViewed();
      if (window.Geo) checkLocation();
      updateVisualViewport();
      window.MBF.updateVisualViewport = updateVisualViewport;
      window.addEventListener("scroll", (0, $gjV2B.debounce)(updateVisualViewport, 10), {
        passive: true
      });
      handleSubscriptionError();
      const initViewportMediaQuery = () => {
        const mediaQuery1024 = window.matchMedia("(max-width: 1024px)");
        const mediaQuery600 = window.matchMedia("(max-width: 600px)");
        const handleViewportChange = () => {
          updateVisualViewport();
        };
        updateVisualViewport();
        mediaQuery1024.addEventListener("change", handleViewportChange);
        mediaQuery600.addEventListener("change", handleViewportChange);
      };
      initViewportMediaQuery();
      window._accessibilityCleanup = cleanup;
    };
    init();
  }
  var $YjNU1 = parcelRequire("YjNU1");
  var $cJzMp = parcelRequire("cJzMp");
  (async () => {
    const log = (0, $cJzMp.createLogger)("main");
    try {
      log("lifecycle", "Initializing core app modules");
      (0, $9ba25b5a4c87c56f$export$c4a8a39c94db4fa4)();
      log("lifecycle", "Modal orchestrator initialized");
      (0, $3d587baaa7c7c73b$export$e838c4b04241f74)();
      log("lifecycle", "Cart module initialized");
      (0, $9a73a619dcb4ee12$export$8b15e3b47cc9809)();
      log("lifecycle", "Cart UI module initialized");
      (0, $3dd422164d2c172f$export$4bb4d890bddbff23)();
      log("lifecycle", "Cart analytics module initialized");
      (0, $YjNU1.initSwymBis)();
      log("lifecycle", "Swym BIS module initialized");
      (0, $2882ac8c1776fa7b$export$3a62f099a1df6abf)();
      log("lifecycle", "Body utilities initialized");
    } catch (coreError) {
      log("errors", "Critical error during core app initialization", (0, $cJzMp.serializeError)(coreError));
      console.error("Critical error initializing core app modules:", coreError);
    }
  })();
})();